﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const __1 = require("..");
const operational_context_client_1 = require("@its-suite/operational-context-client");
class OrganizationSaga {
    static *watcher() {
        yield effects_1.takeLatest(__1.SagaActions.SagaTriggerActionTypes.TRIGGER_UPDATE_ORGANIZATIONS, OrganizationSaga.updateOrganizations);
    }
    static *updateOrganizations() {
        let companyApiClient = new operational_context_client_1.CompanyClient();
        try {
            let organizations = yield effects_1.call([companyApiClient, companyApiClient.getAll]);
            yield effects_1.put(__1.OrganizationModule.actionCreators.updateOrganizations(organizations));
        }
        catch (exception) {
            let normalizedExceptionMessage = exception.response ? exception.response : exception.toString();
            console.log(`Error in OrganizationSaga ${normalizedExceptionMessage}`);
        }
    }
}
exports.OrganizationSaga = OrganizationSaga;
//# sourceMappingURL=OrganizationSaga.js.map